var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-breadcrumb-bar',{attrs:{"pageTitle":`Manage ${_vm.tabs[_vm.tab].text}`}},[_c('v-row')],1),_c('div'),_c('area-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }